import React, { useState, useEffect } from "react";
import { apiClient } from "../../../services/api/apiClient";
import AddPipeFittingModal from "../Pipes/AddPipeFittingModal";

function AddUnistrutModal({
  isOpen,
  onClose,
  trade,
  submittalId,
  onSuccess,
  editData,
}) {
  const [formData, setFormData] = useState({
    material: "",
    insulation: false,
    unistrutProduct: "",
  });
  const [materials, setMaterials] = useState([]);
  const [unistrutProducts, setUnistrutProducts] = useState([]);
  const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [materialsResponse, unistrutProductsResponse] = await Promise.all(
          [
            apiClient.get("/materials"),
            apiClient.get(
              "/products?product_type_id=d3d4f746-5668-49a6-a945-46213f431bcd"
            ),
          ]
        );

        setMaterials(materialsResponse?.data || []);
        // setUnistrutProducts(unistrutProductsResponse);
        setUnistrutProducts(unistrutProductsResponse?.data || []  );
      } catch (error) {
        console.error("Error fetching materials and unistrut products:", error);
        setMaterials([]);
        setUnistrutProducts([]);
      }
    };

    fetchData();
  }, []);

  // Populate form when editData is provided
  useEffect(() => {
    if (editData && materials.length > 0 && unistrutProducts.length > 0) {
      console.log("Setting unistrut form data for edit:", editData);
      setFormData({
        material: editData.material || "",
        insulation: editData.insulation || false,
        unistrutProduct: editData.unistrut_product || "",
      });
    } else if (!editData) {
      // Reset form for new entries
      setFormData({
        material: "",
        insulation: false,
        unistrutProduct: "",
      });
    }
  }, [editData, isOpen, materials, unistrutProducts]);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate that submittalId is provided
    if (!submittalId) {
      alert("Error: No submittal ID provided. Cannot save unistrut.");
      console.error("submittalId is missing:", submittalId);
      return;
    }

    console.log("Submitting unistrut with submittalId:", submittalId);

    try {
      const result = editData
        ? await apiClient.put(`/hangers/unistrut/${editData.id}`, {
            pvfsubmittal_id: submittalId,
            material: formData.material,
            insulation: formData.insulation,
            unistrut_product: formData.unistrutProduct,
            trade: trade,
          })
        : await apiClient.post("/hangers/unistrut", {
            pvfsubmittal_id: submittalId,
            material: formData.material,
            insulation: formData.insulation,
            unistrut_product: formData.unistrutProduct,
            trade: trade,
          });

              const responseData = result.data;
        
        if (result && result.success) {
        console.log(
          `Unistrut ${editData ? "updated" : "saved"} successfully:`,
          responseData
        );
        // Close modal and reset form
        onClose();
        setFormData({
          material: "",
          insulation: false,
          unistrutProduct: "",
        });
        // Call onSuccess callback to refresh the parent component
        if (onSuccess) {
          onSuccess();
        }
      } else {
        console.error(
          `Error ${editData ? "updating" : "saving"} unistrut:`,
          result
        );
        alert(`Error ${editData ? "updating" : "saving"} unistrut: ` + result);
      }
    } catch (error) {
      console.error("Error submitting unistrut data:", error);
      alert("Error submitting unistrut data. Please try again.");
    }
  };

  const refreshProducts = async () => {
    try {
      const unistrutProductsResponse = await apiClient.get(
        "/products?product_type_id=d3d4f746-5668-49a6-a945-46213f431bcd"
      );
      // setUnistrutProducts(unistrutProductsResponse);
      // this will change once we update products
      setUnistrutProducts(unistrutProductsResponse.data);
    } catch (error) {
      console.error("Error refreshing products:", error);
    }
  };

  const openAddProductModal = () => {
    setIsAddProductModalOpen(true);
  };

  const closeAddProductModal = () => {
    setIsAddProductModalOpen(false);
    refreshProducts(); // Refresh products when modal closes
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-[53]">
      <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-900">
            {editData ? "Edit Unistrut" : "Add Unistrut"}
          </h2>
          <div className="flex items-center space-x-3">
            <button
              type="button"
              onClick={openAddProductModal}
              className="px-2 py-1 text-xs font-medium text-green-600 border border-green-600 rounded hover:bg-green-50"
            >
              Add Product
            </button>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              ×
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Material
            </label>
            <select
              name="material"
              value={formData.material}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="">Select Material</option>
              {materials.map((material) => (
                <option key={material.id} value={material.name}>
                  {material.name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              name="insulation"
              id="insulation"
              checked={formData.insulation}
              onChange={handleInputChange}
              className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
            />
            <label htmlFor="insulation" className="ml-2 text-sm text-gray-700">
              Insulated
            </label>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Unistrut Product
              </label>
              <select
                name="unistrutProduct"
                value={formData.unistrutProduct}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                <option value="">Select Unistrut Product</option>
                {unistrutProducts.map((product) => (
                  <option key={product.id} value={product.name}>
                    {product.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
            >
              {editData ? "Update Unistrut" : "Add Unistrut"}
            </button>
          </div>
        </form>
      </div>

      {/* Add Product Modal */}
              <AddPipeFittingModal
          isOpen={isAddProductModalOpen}
          onClose={closeAddProductModal}
        />
    </div>
  );
}

export default AddUnistrutModal;
